// extracted by mini-css-extract-plugin
module.exports = {"container":"RolesSelector_container__1puWs"};